import { FC } from 'react'
import { ISerie } from '../../../../common/interfaces'

interface IProps {
  series: ISerie[]
  value: number | ''
  onChange: (serieId: number | '') => void
  loading?: boolean
}

export const SerieSelect: FC<IProps> = ({ series, value, onChange, loading }) => {
  const isSingleSerie = series.length === 1

  return (
    <div className='col-lg-6 mb-7'>
      <label htmlFor='serie' className='text-muted fs-6 mb-2 d-flex align-items-center gap-2'>
        Serie
        {loading && (
          <span className='spinner-border spinner-border-sm text-primary' role='status' />
        )}
      </label>
      <select
        id='serie'
        className='selectForm contract-select-toggle'
        value={isSingleSerie ? series[0].id : value}
        disabled={isSingleSerie || loading}
        onChange={(e) => onChange(e.target.value === '' ? '' : Number(e.target.value))}
      >
        <option value=''>Seleccione</option>
        {series.map((serie) => (
          <option key={serie.id} value={serie.id}>
            {serie.name}
          </option>
        ))}
      </select>
    </div>
  )
}
